import React from "react";
import { Form, Label, FormGroup } from "reactstrap";
import PropTypes from "prop-types";

import { FormField, CheckFormField } from "../../../../../utils/FormFields";

function ProfileTab({ account, changedAccount, showChanges }) {
  return (
    <Form>
      <Label style={{ fontWeight: 500, fontSize: "20px", display: "block" }}>
        {showChanges ? "New changes" : "Actual Account"}
      </Label>
      {showChanges ? (
        <FormGroup tag="fieldset">
          <FormToShow account={changedAccount} refAccount={account} />
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          <FormToShow account={account} />
        </FormGroup>
      )}
    </Form>
  );
}

ProfileTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default ProfileTab;

const FormToShow = ({ account, refAccount }) => (
  <React.Fragment>
    <FormField label="Account Name: " value={account.AccountName} name="" />
    <FormField label="Number: " value={account.AccountNumber} name="" />
    <FormField label="Account Type: " value={account.AccountIsPhysical ? "Physical" : "Juridical"} name="" />
    <FormField
      label="Currency: "
      changedColor={
        refAccount && parseInt(account.AccountCurrencyId, 10) !== parseInt(refAccount.AccountCurrencyId, 10)
      }
      value={account.AccountCurrencyISO}
      name=""
    />
    <FormField
      label="Company Link: "
      changedColor={
        refAccount &&
        parseInt(account.AccountCompanyLinkId, 10) !== parseInt(refAccount.AccountCompanyLinkId, 10)
      }
      name=""
      value={account.AccountCompanyLinkName}
    />
    <CheckFormField
      label="Automatic Credit Sink: "
      changedColor={
        refAccount && account.AccountAutomaticCreditSink !== refAccount.AccountAutomaticCreditSink
      }
      initialValue={account.AccountAutomaticCreditSink}
      value={account.AccountAutomaticCreditSink}
      name=""
    />
    <CheckFormField
      label="Automatic Credit Coupon: "
      changedColor={
        refAccount && account.AccountAutomaticCreditCoupon !== refAccount.AccountAutomaticCreditCoupon
      }
      value={account.AccountAutomaticCreditCoupon}
      initialValue={account.AccountAutomaticCreditCoupon}
      name=""
    />
    <CheckFormField
      label="Asks Custody: "
      changedColor={refAccount && account.AccountAsksCustody !== refAccount.AccountAsksCustody}
      value={account.AccountAsksCustody}
      initialValue={account.AccountAsksCustody}
      name=""
    />
    {account.AccountIsPhysical == false && (
      <CheckFormField
        label="Account Use Markup: "
        changedColor={refAccount && account.AccountUseMarkUP !== refAccount.AccountUseMarkUP}
        value={account.AccountUseMarkUP}
        initialValue={account.AccountUseMarkUP}
        name=""
      />
    )}
    <FormField
      label="Email: "
      changedColor={refAccount && account.AccountEmail !== refAccount.AccountEmail}
      name=""
      value={account.AccountEmail}
    />
    <FormField
      label="Way Give Orders: "
      changedColor={refAccount && account.AccountWayGiveOrders !== refAccount.AccountWayGiveOrders}
      name=""
      value={account.AccountWayGiveOrders}
    />
    <FormField
      label="Book Info: "
      changedColor={refAccount && account.AccountBookInfo !== refAccount.AccountBookInfo}
      name=""
      value={account.AccountBookInfo}
    />
    <FormField
      label="Account Usage: "
      changedColor={refAccount && account.AccountUsage !== refAccount.AccountUsage}
      name=""
      value={account.AccountUsage}
    />
    <FormField
      label="Founds Origin: "
      changedColor={refAccount && account.AccountFoundsOrigin !== refAccount.AccountFoundsOrigin}
      name=""
      value={account.AccountFoundsOrigin}
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  account: PropTypes.object.isRequired,
  refAccount: PropTypes.object,
};

FormToShow.defaultProps = {
  refAccount: undefined,
};
